// Catálogos de "Outros processos" (mesmos códigos de
// app/Models/Enums/OtherProceedingEnum.js na API). A API também devolve tudo em
// /api/admin/other-proceedings/catalogs; aqui ficam os rótulos e as cores.

export const natures = [
    { id: 1, name: "Judicial" },
    { id: 2, name: "Administrativa" },
];

export const processTypes = [
    { id: 1, name: "Processo trabalhista", nature: 1 },
    { id: 2, name: "Processo cível", nature: 1 },
    { id: 3, name: "Cumprimento de sentença", nature: 1 },
    { id: 4, name: "Execução fiscal", nature: 1 },
    { id: 5, name: "Ação ordinária", nature: 1 },
    { id: 6, name: "Processo administrativo", nature: 2 },
    { id: 7, name: "Outro" },
];

export const statuses = [
    { id: 1, name: "Cadastrado", tone: "neutral" },
    { id: 2, name: "Aguardando análise", tone: "neutral" },
    { id: 3, name: "Em análise", tone: "info" },
    { id: 4, name: "Aguardando documentação", tone: "warning" },
    { id: 5, name: "Aguardando providência", tone: "warning" },
    { id: 6, name: "Aguardando resposta", tone: "warning" },
    { id: 7, name: "Respondido", tone: "success" },
    { id: 8, name: "Encerrado", tone: "neutral" },
];

export const knowledgeTypes = [
    { id: 1, name: "Ofício" },
    { id: 2, name: "Intimação" },
    { id: 3, name: "E-mail do juízo ou secretaria" },
    { id: 4, name: "Comunicação da recuperanda" },
    { id: 5, name: "Comunicação do credor" },
    { id: 6, name: "Consulta direta" },
    { id: 7, name: "Outra" },
];

export const personTypes = [
    { id: 1, name: "Pessoa física" },
    { id: 2, name: "Pessoa jurídica" },
    { id: 3, name: "Órgão público" },
    { id: 4, name: "Outro" },
];

export const partyRoles = [
    { id: 1, name: "Reclamante / autor" },
    { id: 2, name: "Reclamada / réu" },
    { id: 3, name: "Terceiro interessado" },
    { id: 4, name: "Credor" },
    { id: 5, name: "Outro" },
];

export const creditOriginTypes = [
    { id: 1, name: "Verbas trabalhistas" },
    { id: 2, name: "Contrato" },
    { id: 3, name: "Título de crédito" },
    { id: 4, name: "Honorários" },
    { id: 5, name: "Tributário" },
    { id: 6, name: "Indenização" },
    { id: 7, name: "Outro" },
];

export const communicationTypes = [
    { id: 1, name: "Ofício" },
    { id: 2, name: "Intimação" },
    { id: 3, name: "E-mail do juízo ou secretaria" },
    { id: 4, name: "Comunicação da recuperanda" },
    { id: 5, name: "Comunicação do credor" },
    { id: 6, name: "Outra" },
];

export const communicationStatuses = [
    { id: 1, name: "Recebida", tone: "neutral" },
    { id: 2, name: "Em análise", tone: "info" },
    { id: 3, name: "Aguardando providência", tone: "warning" },
    { id: 4, name: "Aguardando resposta", tone: "warning" },
    { id: 5, name: "Respondida", tone: "success" },
    { id: 6, name: "Encerrada", tone: "neutral" },
];

export const taskStatuses = [
    { id: 1, name: "Pendente", tone: "warning" },
    { id: 2, name: "Em andamento", tone: "info" },
    { id: 3, name: "Aguardando informação", tone: "warning" },
    { id: 4, name: "Concluída", tone: "success" },
    { id: 5, name: "Cancelada", tone: "neutral" },
];

export const taskPriorities = [
    { id: 1, name: "Baixa", tone: "neutral" },
    { id: 2, name: "Média", tone: "info" },
    { id: 3, name: "Alta", tone: "warning" },
    { id: 4, name: "Urgente", tone: "danger" },
];

// "needs" diz quais campos o formulário do reflexo exige para cada tipo.
export const impactTypes = [
    { id: 1, name: "Inclusão de crédito", needs: ["amount", "class"], hint: "Cria um crédito novo para a parte no QGC vigente." },
    { id: 2, name: "Redução de crédito", needs: ["source", "amount"], hint: "O crédito de origem passa a valer o valor informado." },
    { id: 3, name: "Substituição de crédito", needs: ["source", "amount", "class"], hint: "Exclui o crédito de origem e cria um novo (para a mesma parte ou para a parte de destino)." },
    { id: 4, name: "Alteração de classe", needs: ["source", "class"], hint: "Troca a classe do crédito de origem." },
    { id: 5, name: "Pagamento parcial", needs: ["source", "amount"], hint: "Abate o valor pago do crédito de origem." },
    { id: 6, name: "Pagamento integral", needs: ["source"], hint: "O crédito de origem passa a zero." },
    { id: 7, name: "Sub-rogação", needs: ["source", "amount", "target"], hint: "Transfere o valor do crédito de origem para o crédito ou a parte de destino." },
    { id: 8, name: "Exclusão por decisão", needs: ["source"], hint: "Exclui o crédito de origem do QGC." },
];

export const impactStatuses = [
    { id: 1, name: "Pendente", tone: "neutral" },
    { id: 2, name: "Aguardando aprovação", tone: "warning" },
    { id: 3, name: "Aplicado no QGC", tone: "success" },
    { id: 4, name: "Rejeitado", tone: "danger" },
    { id: 5, name: "Cancelado", tone: "neutral" },
];

export const currencies = [
    { id: 1, name: "BRL (R$)" },
    { id: 2, name: "USD ($)" },
    { id: 3, name: "EUR (€)" },
];

export const dueStates = [
    { id: "overdue", name: "Vencido", tone: "danger" },
    { id: "upcoming", name: "Próximo do vencimento", tone: "warning" },
    { id: "on_time", name: "No prazo", tone: "success" },
    { id: "none", name: "Sem prazo", tone: "neutral" },
];

export const movementTypeSuggestions = [
    "Distribuição", "Citação / notificação", "Audiência designada", "Audiência realizada", "Sentença", "Recurso interposto",
    "Acórdão", "Trânsito em julgado", "Cálculo de liquidação", "Penhora / bloqueio", "Alvará", "Ofício expedido", "Manifestação da AJ", "Outra",
];

export function labelOf(catalog, id, fallback = "—") {
    const item = catalog.find((entry) => String(entry.id) === String(id));
    return item ? item.name : fallback;
}

export function toneOf(catalog, id, fallback = "neutral") {
    const item = catalog.find((entry) => String(entry.id) === String(id));
    return item && item.tone ? item.tone : fallback;
}
